export const colors = {
  primary: "#06b992",
  primaryShade: "#01685e",
  primaryDark: "#0e5654",
  secondary: "#cac0fc",
  secondaryShade: "#a787d9",
  secondaryDark: "#540389",
  white: "#f7f4eb",
  tertiary: "#d5e065",
  quaternary: "#f96e09",
};
